<template>
  <div class="questionnaire" v-if="userInfo">
    <Header></Header>
    <div class="userinfo-card">
      <div class="my-card">
        <div class="my-card-header">
          <div class="left"></div>
          <div class="right">
            SHARE YOUR COMMENTS! EXPRESS YORI THOUGHTS! GET REWARDS!
          </div>
          <div class="mobile-sign">SIGN IN</div>
        </div>

        <div class="my-card-info">
          <img class="avatarUrl" :src="userInfo.avatarUrl" />
          <div class="infos">
            <div class="infos-top">
              <div class="infos-top-left">
                <div class="name">
                  <div>{{ userInfo.userName }}</div>
                  <div class="imgs">
                    <img
                      src="@/assets/pcImg/questionnaire/zhifubao.png"
                      alt="图片"
                    />
                    <img
                      src="@/assets/pcImg/questionnaire/paypal.png"
                      alt="图片"
                    />
                  </div>
                </div>
                <div class="emali">{{ name }}</div>
              </div>
              <div class="mobile-infos-left">
                <div class="mobile-infos-lefts">
                  <div>
                    <img class="avatarUrl" :src="userInfo.avatarUrl" />
                  </div>
                  <div class="user-info">
                    <div class="user-name">{{ userInfo.userName }}</div>
                    <div class="emali">{{ userInfo.email }}</div>
                  </div>
                </div>
                <div class="mobile-img-boxs" @click="skip('/currentLevel')">
                  <img
                    class="medal"
                    src="@/assets/pcImg/questionnaire/medal.png"
                  />
                  <div class="medal-lv">LV.1</div>
                </div>
              </div>
              <div class="infos-top-right">SIGN IN</div>
            </div>
            <div class="infos-line"></div>
            <div class="infos-bottom">
              <div class="img-boxs-available">
                <div class="available">Available balance</div>
                <div class="img-info">
                  <img
                    class="dollar"
                    src="@/assets/pcImg/questionnaire/$.png"
                  />
                  <div class="dollar-number">{{ userInfo.balance }}</div>
                </div>
              </div>
              <div class="img-boxs">
                <img
                  class="cashout"
                  src="@/assets/pcImg/questionnaire/cashout.png"
                />
                <div class="cashout-text">Cashout</div>
              </div>
              <div
                class="img-boxs img-boxs-mobile"
                @click="skip('/currentLevel')"
              >
                <img
                  class="medal"
                  src="@/assets/pcImg/questionnaire/medal.png"
                />
                <div class="medal-lv">LV.1</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        class="question-mark"
        src="@/assets/pcImg/questionnaire/question-mark.png"
        alt="图片"
      />
    </div>

    <div class="questionnaire-list">
      <div class="earn-cash">
        <div>Complete Surveys and Earn Cash</div>
        <div class="see-more">
          <span>See more</span>
          <img src="@/assets/pcImg/questionnaire/arrowhead.png" alt="图片" />
        </div>
      </div>

      <div class="questionnaire-item-fa">
        <div
          class="questionnaire-item"
          v-for="(item, index) in IndividualSurveysArr"
          :key="index"
        >
          <div class="number-maxPoints">
            <div class="number">
              <div class="identifier">{{ item.number }}</div>
              <div>{{ item.title }}</div>
            </div>
            <div class="maxPoints">$ {{ item.maxPoints | getDollar }}</div>
          </div>

          <div class="facility-value">
            <div class="value">Facility value</div>
            <div class="progress-ga">
              <div class="progress-fa">
                <van-progress
                  color="#2E67EA"
                  track-color="#E0E6F4"
                  :show-pivot="false"
                  :percentage="item.ir"
                />
              </div>
              <div class="percentage">{{ item.ir }}%</div>
            </div>
          </div>

          <div class="clock-join">
            <div>
              <img
                class="clock"
                src="@/assets/pcImg/questionnaire/clock.png"
                alt="图片"
              />
              <span>{{ item.loi }}min</span>
            </div>
            <div class="join">JOIN IN</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 文本框 -->
    <div class="text-box">
      <p>{{ questionnaireTexts[0] }}</p>
      <p>{{ questionnaireTexts[1] }}</p>
    </div>

    <!-- 文本框2 -->
    <div class="introduction-box">
      <div class="introduction-left">
        <div class="title">Introduction to your survey</div>
        <div class="profile">
          Answer profile questions to obtain more survey matches
        </div>
        <div class="earn">Earn $0.02 for every 10 Questions</div>
        <div class="introduction-progress">
          <div>
            <van-progress
              color="#2E67EA"
              track-color="#E0E6F4"
              :show-pivot="false"
              :percentage="50"
            />
          </div>
          <div>50%</div>
        </div>
      </div>
      <div class="introduction-right">
        <div class="title">
          When you fly, which types of flights do you take?
        </div>
        <div class="answer">
          <span>回答</span>
          <img
            :class="['answer-arrowhead', { 'answer-rotate0': developStatus }]"
            src="@/assets/pcImg/questionnaire/arrowhead.png"
            alt="图片"
            @click="develop"
          />
        </div>
        <div class="answers">
          <div
            :class="['answer-item', { 'answer-item-border': index !== 0 }]"
            v-for="(item, index) in answerList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div class="buttons">
          <div>The Previous</div>
          <div>Answer</div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import { accounts } from "@/api/api.js";
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import { IndividualSurveys, users } from "@/api/api.js";
import { Notify } from "vant";
import { questionnaire } from "@/utlis/storageData.js";

//  v-bind:percentage="item | medalPercentage"
export default {
  filters: {
    getDollar: (data) => {
      // data/100
      return data / 100;
    },
  },
  components: { Header, Footer },
  data() {
    return {
      loginInfo: null,
      userInfo: null,
      IndividualSurveysArr: [],
      questionnaireTexts: questionnaire,
      answerList: [1, 2, 3, 4, 5, 6],
      developStatus: false,
      name: "",
    };
  },
  methods: {
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
    //获取用户信息
    async initPage() {
      //用户信息
      this.userInfo = JSON.parse(localStorage.getItem("accountInfo"));
      if (this.userInfo) return;
      const params = {
        id: this.loginInfo.id,
      };
      await accounts(params).then((res) => {
        if (res.code === 200) {
          this.$store.commit("setAccountInfo", res.data);
          this.userInfo = res.data;
          console.log("获取用户信息", this.userInfo);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //获取问卷信息
    getIndividualSurveys() {
      const params = {
        id: this.loginInfo.id,
      };
      IndividualSurveys(params).then((res) => {
        if (res.code === 200) {
          this.IndividualSurveysArr = res.data;
          console.log(11, this.IndividualSurveysArr);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //展开回答
    develop() {
      this.developStatus = !this.developStatus;
      if (this.developStatus) {
        document.getElementsByClassName("answers")[0].style.height =
          32 * this.answerList.length + "px";
      } else {
        document.getElementsByClassName("answers")[0].style.height = 0;
      }
    },
    //
    getName() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      users(params).then((res) => {
        //console.log(res);
        if (res.code === 200) {
          console.log("res", res.data);
          this.name = res.data.name;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
  },
  created() {
    this.loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));

    if (!this.loginInfo) return;
    this.initPage();
    this.getName();
    this.getIndividualSurveys();
    console.log("头部重新渲染", this.loginInfo);
  },
};
</script>
<style scoped>
.questionnaire {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.userinfo-card {
  width: 100%;
  height: 180px;
  background-color: #2e67ea;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.my-card {
  width: 500px;
  height: 128.125px;
  background-color: #fff;
  border-radius: 6.25px;
  overflow: hidden;
}
.my-card-header {
  height: 36.875px;
  background-color: #5b90f2;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.my-card-header > .left {
  width: 10px;
  height: 10px;
  background: #efdc00;
  border-radius: 10px;
}
.my-card-header > .right {
  font-size: 11.25px;
  font-weight: bold;
  color: #ffffff;
}
.my-card-info {
  display: flex;
  margin-top: 10.625px;
}
.my-card-info > .avatarUrl {
  height: 37.5px;
  width: 37.5px;
  border-radius: 37.5px;
  background-color: #cccccc;
  margin-left: 6.25px;
}
.infos {
  width: calc(100% - 80px);
  margin-left: 13.75px;
}
.infos-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.infos-top-left > .name {
  display: flex;
  align-content: center;
  margin-top: 5px;
}
.infos-top-left > .name > .imgs {
  display: flex;
  align-content: center;
  margin-left: 35.625px;
}
.infos-top-left > .name > .imgs > img {
  width: auto;
  height: 10px;
  margin-right: 5px;
}
.infos-top-left > .name > div {
  font-size: 10px;
  font-weight: bold;
  color: #232323;
}
.infos-top-left > .emali {
  font-size: 8.75px;
  font-weight: bold;
  color: #666666;
  margin-top: 8.125px;
}
.infos-top-right {
  width: 56.25px;
  height: 22.5px;
  line-height: 22.5px;
  background: #2e67ea;
  border-radius: 15px;
  font-size: 8.75px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
}
.infos-line {
  height: 0;
  border-top: 0.625px solid #eeeeee;
  margin-top: 6.25px;
}
.infos-bottom {
  display: flex;
  align-items: flex-end;
}
.img-boxs-available {
  display: flex;
  flex-direction: column;
}
.available {
  font-size: 7.5px;
  color: #666666;
  margin-top: 6.25px;
}
.img-info {
  display: flex;
  justify-content: space-around;
  margin-top: 6.25px;
}
.dollar {
  width: 11.25px;
}
.dollar-number {
  font-size: 11.25px;
  font-weight: bold;
  color: #232323;
}
.img-boxs {
  display: flex;
  margin-left: 40px;
  align-items: center;
  cursor: pointer;
}
.cashout {
  width: 15px;
  position: relative;
  top: 2px;
}
.cashout-text {
  width: 31.25px;
  height: 11.25px;
  line-height: 11.25px;
  background: rgba(46, 103, 234, 0.1);
  border-radius: 1.875px;
  font-size: 7.5px;
  position: relative;
  top: 2px;
  color: #2e67ea;
  margin-left: 2px;
  text-align: center;
}
.medal {
  width: 18.75px;
  position: relative;
  right: -16px;
}
.medal-lv {
  width: 36.875px;
  height: 15.625px;
  line-height: 15.625px;
  background: rgba(46, 103, 234, 0.1);
  border-radius: 10px;
  font-size: 8.75px;
  font-weight: bold;
  color: #2e67ea;
  text-align: right;
  padding-right: 10px;
  position: relative;
  top: 0.5px;
}
.question-mark {
  width: 133.75px;
  height: 133.75px;
}

/* 问卷列表 */
.questionnaire-list {
  width: calc(100% - 175px);
  margin: 37.5px auto;
}
.earn-cash {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11.25px;
  font-weight: bold;
  color: #232323;
}

.see-more {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.see-more > span {
  font-size: 8.75px;
  font-weight: normal;
  color: #232323;
}
.see-more > img {
  width: 10px;
  margin-top: 2px;
  margin-left: 10px;
}

.questionnaire-item-fa {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}
.questionnaire-item {
  width: 153.125px;
  height: 143.75px;
  background: #f5f5f5;
  margin-top: 25px;
  border-radius: 4px;
  margin-right: calc((100% - 612.5px) / 3);
}
.questionnaire-item:nth-of-type(4n + 0) {
  margin-right: 0;
}
.number-maxPoints {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 18.75px;
}
.number-maxPoints > .number {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  color: #232323;
  margin-left: 12.5px;
  font-size: 8px;
}
.identifier {
  font-size: 9px;
  margin-bottom: 12.5px;
}
.maxPoints {
  width: 63.125px;
  height: 33.75px;
  background: #2e67ea;
  box-shadow: 0px 1.875px 5.625px 0.625px rgba(51, 106, 234, 0.55);
  border-radius: 5.625px;
  line-height: 33.75px;
  text-align: center;
  color: #fff;
  margin-right: 12.5px;
  font-weight: bold;
}
.facility-value {
  display: flex;
  flex-direction: column;
  margin-top: 21.875px;
  margin-left: 12.5px;
}
.facility-value > .value {
  font-size: 7.5px;
  color: #999999;
}
.progress-ga {
  display: flex;
  margin-top: 6.25px;
  align-items: center;
}
.progress-fa {
  width: 54.375px;
}
.percentage {
  font-size: 7.5px;
  color: #999999;
  margin-left: 5px;
}
.clock-join {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12.5px;
}
.clock-join img {
  width: 15px;
  margin-left: 12.5px;
}
.clock-join span {
  font-size: 10px;
  font-weight: 400;
  color: #666666;
}
.clock-join .join {
  width: 55px;
  height: 18.75px;
  line-height: 18.75px;
  border-radius: 9.375px;
  border: 0.625px solid #2e67ea;
  font-size: 8.75px;
  font-weight: bold;
  color: #2e67ea;
  text-align: center;
  margin-right: 12.5px;
}
/* 文本框 */
.text-box {
  width: calc(100% - 207.5px);
  margin: 37.5px auto;
  background: #f5f5f5;
  border-radius: 2.5px;
  padding: 24px 16.25px;
  font-size: 8.75px;
  line-height: 15px;
}
.text-box > p:nth-child(1) {
  font-weight: 400;
  color: #b22525;
}
.text-box > p:nth-child(2) {
  font-weight: 400;
  margin-top: 24px;
  color: #232323;
}
/* 文本框2 */
.introduction-box {
  width: calc(100% - 207.5px);
  margin: 37.5px auto;
  background: #f5f5f5;
  border-radius: 2.5px;
  padding: 24px 16.25px;
  font-size: 8.75px;
  line-height: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.introduction-left {
  padding-right: 10px;
}
.introduction-left > .title {
  font-size: 11.25px;
  font-weight: bold;
  color: #232323;
  margin-bottom: 16px;
}
.introduction-left > .profile {
  font-size: 8.75px;
  font-weight: 400;
  color: #232323;
}
.introduction-left > .earn {
  font-size: 10px;
  font-weight: bold;
  color: #232323;
  margin: 16px 0;
}
.introduction-left > .introduction-progress {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.introduction-progress > div:nth-child(1) {
  width: calc(100% - 30px);
}
.introduction-progress > div:nth-child(2) {
  color: #999999;
  margin-left: 10px;
}
.introduction-right {
  width: 428.75px;
  height: auto;
  background-color: #fff;
}
.introduction-right > .title {
  width: 100%;
  text-align: center;
  font-size: 11.25px;
  font-weight: bold;
  color: #232323;
  margin-top: 15px;
}
.answer {
  width: calc(100% - 30px);
  background-color: #f5f5f5;
  margin: 0 auto;
  font-size: 8.75px;
  text-align: center;
  position: relative;
  height: 18.75px;
  line-height: 18.75px;
  margin-top: 10px;
}
.answer-arrowhead {
  width: 10px;
  position: absolute;
  top: 4px;
  right: 5px;
  cursor: pointer;
  transform: rotate(0deg);
  transition: transform 0.3s;
}
.answer-rotate0 {
  transform: rotate(90deg);
}
.answers {
  width: calc(100% - 30px);
  margin: 0 auto;
  height: 0;
  overflow: hidden;
  transition: height 0.3s;
}
.answer-item {
  border: 0.625px solid #eeeeee;
  height: 18.75px;
  line-height: 18.75px;
  text-align: center;
  cursor: pointer;
}
.answer-item-border {
  border-top: none;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  margin-right: 15px;
  margin-bottom: 20px;
}
.buttons > div {
  height: 18.75px;
  line-height: 18.75px;
  border-radius: 10px;
  padding: 0 10px;
  border: 0.625px solid #232323;
  color: #232323;
  font-size: 8.75px;
  margin-left: 10px;
  cursor: pointer;
}
.buttons > div:nth-child(2) {
  border: 0.625px solid #2e67ea;
  color: #2e67ea;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1290px) {
  .question-mark {
    display: none;
  }
  .questionnaire-list {
    width: calc(100% - 60px);
  }
  .text-box,
  .introduction-box {
    width: calc(100% - 92.5px);
  }
}
@media only screen and (max-width: 1111px) {
  .questionnaire-item {
    width: 153.125px;
    height: 143.75px;
    background: #f5f5f5;
    margin-top: 25px;
    border-radius: 4px;
    margin-right: calc((100% - 459.375px) / 2);
  }
  .questionnaire-item:nth-of-type(3n) {
    margin-right: 0;
  }
  .questionnaire-item:nth-of-type(4n) {
    margin-right: calc((100% - 459.375px) / 2);
  }
}
@media only screen and (max-width: 840px) {
  .my-card {
    width: 450px;
  }
  .questionnaire-list {
    width: calc(100% - 8px);
  }
  .text-box,
  .introduction-box {
    width: calc(100% - 40.5px);
  }
}
</style>
<style scoped>
/* 进入移动端 */
.mobile-sign {
  display: none;
  width: 44.375px;
  height: 16.25px;
  line-height: 16.25px;
  background: #0551ff;
  border-radius: 16.25px;
  font-size: 7.5px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  font-weight: normal;
}
.mobile-infos-left {
  display: none;
  justify-content: space-between;
  align-items: center;
}
.mobile-infos-lefts {
  display: flex;
}
.mobile-infos-left .avatarUrl {
  height: 37.5px;
  width: 37.5px;
  border-radius: 37.5px;
  background-color: #cccccc;
  margin-left: 6.25px;
}
.mobile-infos-left .user-info {
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-left: 10px;
  justify-content: space-between;
}
.mobile-infos-lefts .user-name {
  font-size: 10px;
  font-weight: bold;
  margin-top: 6px;
}
.mobile-infos-lefts .emali {
  font-size: 7.5px;
  margin-bottom: 6px;
}
.mobile-img-boxs {
  display: flex;
  margin-right: 10px;
  cursor: pointer;
}
.mobile-img-boxs > img {
  width: 13.75px;
  height: 13.75px;
  position: relative;
  left: 15px;
}
.mobile-img-boxs > div {
  width: 31.25px;
  height: 13.75px;
  font-size: 7.5px;
  line-height: 13.75px;
}
@media only screen and (max-width: 751px) {
  .my-card {
    width: calc(100% - 20px);
  }
  .mobile-sign {
    display: block;
  }
  .my-card-header {
    justify-content: space-around;
  }
  .my-card-header > .right {
    width: 200px;
    font-size: 8.75px;
    line-height: 13px;
  }
  .infos-top-right {
    display: none;
  }
  .my-card-info > .avatarUrl {
    display: none;
  }
  .infos-top-left {
    display: none;
  }
  .mobile-infos-left {
    display: flex;
    width: 100%;
  }
  .infos {
    width: 100%;
  }
  .img-boxs-mobile {
    display: none;
  }
  .infos-bottom {
    justify-content: space-between;
  }
  .infos-bottom .img-boxs {
    margin-right: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/questionnaire.vue